import { api } from './client';

/** Endpoints del módulo Pendientes del Vendedor. Prefijo: /api/pendientes */

export type PendienteEstado =
  | 'DETECTADO'
  | 'PROGRAMADO'
  | 'AVISADO'
  | 'RESPONDIDO'
  | 'CUMPLIDO'
  | 'VENCIDO'
  | 'DESCARTADO';

export type PendienteTipo =
  | 'LLAMAR'
  | 'ESCRIBIR'
  | 'ENVIAR_INFO'
  | 'COTIZACION'
  | 'SEGUIMIENTO'
  | 'OTRO';

export interface Pendiente {
  id: string;
  /** El código que el vendedor copia al responder (P-0001). */
  codigo: string;
  conversationId: string;
  contactId: string;
  vendedorUserId: string | null;
  tipo: PendienteTipo;
  esVenta: boolean;
  descripcion: string;
  /** De dónde salió: la cita textual y quién la dijo. */
  evidenciaJson: { quote?: string; quien?: string; motivoDescarte?: string } | null;
  fechaCompromiso: string;
  estado: PendienteEstado;
  origen: 'IA' | 'REGLA' | 'MANUAL';
  avisosJson: { canal: string; ts: string; resultado: string }[] | null;
  avisadoAt: string | null;
  respondidoAt: string | null;
  cumplidoAt: string | null;
  createdAt: string;
  contact?: { name: string | null; pushName: string | null; phone: string | null } | null;
  vendedor?: { id: string; name: string | null; email: string; telefono: string | null } | null;
}

export interface KpiVendedor {
  vendedorUserId: string | null;
  nombre: string;
  total: number;
  cumplidos: number;
  vencidos: number;
  /** null cuando todavía no hay nada cerrado que medir. */
  porcentaje: number | null;
}

export interface KpisPendientes {
  detectados7d: number;
  abiertos: number;
  vencidos: number;
  cumplidos7d: number;
  porVendedor: KpiVendedor[];
}

export interface ListarPendientesParams {
  estado?: PendienteEstado;
  vendedorUserId?: string;
  esVenta?: boolean;
  limit?: number;
}

export const listarPendientes = (params: ListarPendientesParams = {}) => {
  const q = new URLSearchParams();
  if (params.estado) q.set('estado', params.estado);
  if (params.vendedorUserId) q.set('vendedorUserId', params.vendedorUserId);
  if (params.esVenta !== undefined) q.set('esVenta', String(params.esVenta));
  if (params.limit) q.set('limit', String(params.limit));
  const qs = q.toString();
  return api.get<Pendiente[]>(`/api/pendientes${qs ? `?${qs}` : ''}`);
};

export const kpisPendientes = () => api.get<KpisPendientes>('/api/pendientes/kpis');

/** Alta manual: el supervisor vio algo en un chat y lo registra. */
export const crearPendiente = (input: {
  conversationId: string;
  tipo: PendienteTipo;
  descripcion: string;
  fechaCompromiso: string;
  esVenta?: boolean;
  vendedorUserId?: string | null;
}) => api.post<Pendiente>('/api/pendientes', input);

/** Reprogramar, reasignar, marcar cumplido o descartar (el motivo es obligatorio). */
export const actualizarPendiente = (
  id: string,
  input: {
    tipo?: PendienteTipo;
    descripcion?: string;
    fechaCompromiso?: string;
    esVenta?: boolean;
    vendedorUserId?: string | null;
    estado?: PendienteEstado;
    motivo?: string;
  },
) => api.patch<Pendiente>(`/api/pendientes/${id}`, input);
